import { useCallback, useState } from '@redneckz/uni-jsx/lib/hooks';
export const useCarouselControls = (props, initialIndex = 0) => {
    const { itemCount, visibleItemCount } = props;
    const [activeIndex, setActiveIndex] = useState(initialIndex);
    const inc = useCallback(() => setActiveIndex((_) => Math.min(_ + 1, itemCount - 1)), [itemCount]);
    const dec = useCallback(() => setActiveIndex((_) => Math.max(_ - 1, 0)), [itemCount]);
    const canInc = visibleItemCount
        ? itemCount > visibleItemCount && activeIndex < itemCount - visibleItemCount
        : activeIndex < itemCount - 1;
    const canDec = activeIndex > 0;
    const isScrollAvailable = canDec || canInc;
    return [
        activeIndex,
        {
            inc,
            dec,
            canInc,
            canDec,
            isScrollAvailable,
        },
    ];
};
//# sourceMappingURL=useCarouselControls.js.map